import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MailTemplateType } from '@mews-commander/data-access';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

const MailTemplateEditorCreate = lazy(async () =>
    import(/* webpackChunkName: "MailTemplateEditorCreate" */ '@mews-commander/email-template-editor').then(
        (module) => ({
            default: module.MailTemplateEditorCreate,
        })
    )
);

const schema = z.object({
    ServiceId: z.string().uuid().optional(),
    Type: z.nativeEnum(MailTemplateType),
});

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/MailTemplateEditor/Create')({
    validateSearch: schema,
    component: Component,
    staticData: {
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
        title: TextKey.MailTemplatePageTitleCreate,
    },
});

function Component() {
    const { ServiceId, Type } = Route.useSearch();
    return <MailTemplateEditorCreate serviceId={ServiceId} mailTemplateType={Type} />;
}
